import axios from "axios";

import { API_ORIGIN } from "./apiConfig";

const API_BASE_URL = `${API_ORIGIN}/usp`;

// Auth headers function
const getAuthHeaders = () => {
    const token = localStorage.getItem("admin_access_token");
    return {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
};

// GET all applications
export const getAllApplications = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/admin/applications`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error: any) {
        console.error("Error fetching applications:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// GET application by ID
export const getApplicationById = async (id: number) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/admin/applications/${id}`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error: any) {
        console.error(`Error fetching application ${id}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// UPDATE application status
export const updateApplicationStatus = async (id: number, status: string) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}/admin/applications/${id}/status`,
            { status },
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error: any) {
        console.error(`Error updating application ${id}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// GET applications by status
export const getApplicationsByStatus = async (status: string) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/admin/applications/status/${status}`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error: any) {
        console.error(`Error fetching applications by status ${status}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// GET applications by job ID
export const getApplicationsByJobId = async (jobId: number) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/admin/applications/job/${jobId}`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error: any) {
        console.error(`Error fetching applications for job ${jobId}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};
